export function BillingSection() {
  return (
    <div className="space-y-4">
      <div className="bg-secondary aspect-video max-w-3xl rounded-xl flex items-center justify-center">
        <p className="text-muted-foreground">
          Billing management and subscription settings coming soon
        </p>
      </div>
    </div>
  )
}
